export default "__VITE_ASSET__z8HsBk_T__"